<template>
  <div class="minor-tip-overlay" v-if="show" @click="$emit('close')">
    <div class="minor-tip-modal" @click.stop>
      <div class="tip-icon">!</div>
      <h3 class="tip-title">{{ title }}</h3>
      <p class="tip-msg">{{ message }}</p>
      <button class="tip-btn" @click="$emit('close')">我已知晓</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MinorTip',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '温馨提示' },
    message: { type: String, default: '' }
  },
  emits: ['close']
};
</script>

<style scoped>
.minor-tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.minor-tip-modal {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 380px;
  padding: 32px 24px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
.tip-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #ff9600;
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  line-height: 56px;
}
.tip-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 12px;
}
.tip-msg {
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
  margin: 0 0 24px;
}
.tip-btn {
  padding: 0 32px;
  height: 40px;
  background: #ff9600;
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
}
</style>
